var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabsLayout',[_c('ElTabPane',{attrs:{"name":"appslist","label":"游戏应用管理"}}),(_vm.$route.name === 'appsadd')?_c('ElTabPane',{attrs:{"name":"appsadd","label":`${_vm.$route.query.t === 'edit' ? '修改' : '新建'}游戏应用`}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }